<template>
  <div>
    <div class="outdoor-pricelist-address" v-if="!isModalLoading">
      <div class="outdoor-pricelist-address__description">
        <h1 class="subhead">Route Description</h1>
        <div class="subhead">{{description}}</div>
      </div>
      <!-- <div class="outdoor-pricelist-address__image">
        <img :src="imageUrl ? imageUrl : placeHolder" alt />
      </div> -->
      <div class="map-wrapper" :key="keyMapRef">
        <GmapMap
          class="map"
          :center="{lat:-6.1944935, lng:106.7643612}"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; position: relative;top: 0; left: 0;right: 0;bottom: 0;height: 140px;"
          ref="mapRef"
          :options="{
            zoomControl: true,
            mapTypeControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false
          }"
          >
        </GmapMap>
      </div>
      <div class="outdoor-pricelist-address__tnc">
       <h1 class="subhead">Route Detail</h1>
       <ul v-if="routeDetails">
        <li class="subhead" v-for="(route, index) in routeDetails" :key="index">{{route}}</li>
       </ul>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";
import { mapGetters } from "vuex"
import { mapListFilter } from '@/lib/transformer'

import { ALoadingPrimary } from "ui-kit-v1";

export default {
  name: "adx-outdoor-placement-address",
  components: {
    "a-loading": ALoadingPrimary
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      description: null,
      routeDetails: [],
      imageUrl: null,
      keyMapRef: false,
      placeHolder: "/img/notfound/img-placeholder_square.jpg"
    };
  },
  computed: {
    google: VueGoogleMaps.gmapApi,
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    })
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.busPricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.description = data.route.description;
        this.routeDetails = data.route.route_details
        if(data.route.route_photo.length > 0){
          this.imageUrl = data.route.route_photo.map(data => data.thumb)
        }
        
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }
      return `${value} ${label}`;
    },
    timeFormatter(value) {
      let valueString = value.toString();
      if (valueString.length < 2) return "0" + valueString;
      return value;
    },
    timeDisplay(time) {
      return `${this.timeFormatter(time.start)} - ${this.timeFormatter(
        time.end
      )} WIB`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
